/** @format */

import React, { useState } from "react";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";
import UberLogo from "./uberLogo";
import { Link, useLocation, useNavigate } from "fusion-plugin-react-router";
import { assetsPath } from "../utils/assetsPath";

const Navbar = () => {
  const css = assetUrl("../../styles/main.css");
  const landingCss = assetUrl("../../styles/landing.css");

  const location = useLocation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const hideHamburgerMenu = [
    "/taxi/quote",
    "/error",
    "/blocked-action",
  ].includes(location.pathname);

  const menuItems = [
    {
      name: "Home",
      icon: assetsPath.heart,
      route: "/landing",
    },
    {
      name: "Report a Claim",
      icon: assetsPath.heart,
      route: "/claim",
    },
    {
      name: "Make a Change",
      icon: assetsPath.heart,
      route: "/support?supportType=changePolicy",
    },
    {
      name: "Cancel Policy",
      icon: assetsPath.heart,
      route: "/support?supportType=cancelPolicy",
    },
    {
      name: "Support",
      icon: assetsPath.heart,
      route: "/landing/contact",
    },
  ];

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <link rel="stylesheet" href={css} />
        <link rel="stylesheet" href={landingCss} />
      </Helmet>
      <nav className="navbar2">
        <div className="navbar-container">
          {hideHamburgerMenu ? (
            <div className="navbar-left non-clickable-logo">
              <UberLogo color="white" width={40} height={40} />
            </div>
          ) : (
            <Link to="/landing" className="navbar-left">
              <UberLogo color="white" width={40} height={40} />
            </Link>
          )}
          {!hideHamburgerMenu && (
            <button
              className="hamburger"
              onClick={() => {
                setIsMenuOpen(!isMenuOpen);
              }}
            >
              <img src={assetsPath.burgerMenu} alt="menu" />
            </button>
          )}
        </div>
        {isMenuOpen && !hideHamburgerMenu && (
          <aside className="portal-menu-nav">
            <ul>
              {menuItems.map((menu) => {
                const isSelected =
                  location.pathname === menu.route.split("?")[0] &&
                  (!menu.route.includes("?") ||
                    location.search === `?${menu.route.split("?")[1]}`);

                return (
                  <li
                    key={menu.name}
                    className={`portalMenuHeading ${
                      isSelected ? "selected-tab" : "default-tab"
                    }`}
                    onClick={() => {
                      if (menu.route) {
                        navigate(menu.route);
                      } else {
                        menu.action();
                      }
                      setIsMenuOpen(false);
                    }}
                  >
                    <img
                      src={isSelected ? menu.icon : assetsPath.grayHeart}
                      alt={`${menu.name} icon`}
                    />
                    <h5 className="menuHeading font-16 margin-y-0">
                      {menu.name}
                    </h5>
                  </li>
                );
              })}
            </ul>
          </aside>
        )}
      </nav>
    </>
  );
};

export default Navbar;
